import { DataBean } from "../DataBean";

export class TransportRoute extends DataBean {



    public async deleteTransportRoute(idTransportRoute: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportRoute_Number", [idTransportRoute]);
    }


    public async getTransportRouteCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportRouteCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

    public async getTransportRouteCatalogByOffice(idOffice: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportRouteCatalogByOffice_Number_String_Number_Number", [idOffice, regexStr, page, recordsPerPage]);
    }

}